/** Public product name (AIOS Control Plane); aligns with marketing site. */
export const BRAND_DISPLAY_NAME = "AIOS CP";
/** Primary positioning line (sidebar / login subtitle). */
export const BRAND_TAGLINE = "The control plane for enterprise AI agents";
/** Legal / registrar-style name (copyright, package scopes). */
export const BRAND_LEGAL_NAME = "AIOSCP";
/** Default app label in settings preview before white-label overrides. */
export const BRAND_APP_DEFAULT_NAME = "AIOS CP";
